<template>
<div>
    <Breadcrumbs main="Admin" submain="System" title="Payment Log" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <!-- <div class="card-header">
                        <div style="max-width: fit-content;">
                            <router-link to="/subscriber/add">
                                <button class="btn btn-primary" type="submit" style="display: flex; gap: 12px; align-items: center;">
                                    <i class="fa fa-light fa-plus"></i>
                                    <h7>Add New subscriber</h7>
                                </button>
                            </router-link>
                        </div>
                    </div> -->

                    <div class="card-body">
                        <b-row class="d-flex justify-content-center align-items-center">
                            <b-col xl="6" class="d-flex flex-wrap" style="gap: 20px">
                                <b-input-group style="width: 340px;">
                                    <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                                    <b-input-group-append>
                                        <b-button @click="filter = ''">Clear</b-button>
                                    </b-input-group-append>
                                </b-input-group>

                                <!-- <div style="display: flex; gap: 12px; align-items: center; color: white; background-color: #262062; padding: 2px 14px; max-width: fit-content; border-radius: 5px; cursor: pointer;" @click="toggleFilterShow()">
                                    <feather type="filter"></feather>
                                    <h7>Filter</h7>
                                </div>

                                <div style="display: flex; gap: 12px; align-items: center; color: white; background-color: #DC3545; padding: 2px 14px; max-width: fit-content; border-radius: 5px; cursor: pointer;" @click="clearFilter()" v-if="filterShow || subscriptionType">
                                    <feather type="x"></feather>
                                    <h7>Clear All</h7>
                                </div> -->
                            </b-col>

                            <b-col xl="6">
                                <b-form-group label-cols="2" label="Per page" class="mb-0 datatable-select">
                                    <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <!-- <div class="row mt-2" v-if="filterShow || subscriptionType">
                            <div class="col-md-4">
                                <div class="grid-container mt-sm-0">
                                    <div class="grid-item">
                                        <span style="margin-bottom: 4px;">Subscription Type</span>
                                        <b-form-select v-model="subscriptionType" :options="formattedSubscription"></b-form-select>
                                    </div>
                                </div>
                            </div>
                        </div> -->

                        <div v-if="!loading && !error && !loadingPage">
                            <div class="table-responsive datatable-vue mt-4">
                                <b-table :items="payment_log" :fields="tablefields" :per-page="perPage" :filter="filter" show-empty stacked="md">
                                    <template #cell(index)="data">
                                        {{ (currentPage - 1) * perPage + data.index + 1 }}
                                    </template>

                                    <template #cell(value_a)="row">
                                        <div style="max-width: 180px;">
                                            <h7>{{ row.item.payment_response?.value_a }}</h7>
                                        </div>
                                    </template>

                                    <template #cell(user)="row">
                                        <div style="display: flex; flex-direction: column; max-width: 200px;">
                                            <h7 style="font-weight: 500;">{{ row.item.user.first_name }} {{ row.item.user.last_name }}</h7>
                                            <h7>{{ row.item.user.email }}</h7>
                                            <h7>Profile ID: <span style="font-weight: 500;">{{ row.item.user.profile_id }}</span></h7>
                                        </div>
                                    </template>

                                    <template #cell(media)="row">
                                        <div style="display: flex; flex-direction: column;">
                                            <h7>Type: {{ row.item.payment_response?.card_type }}</h7>
                                            <h7>Issuer: {{ row.item.payment_response?.card_issuer }}</h7>
                                            <h7>Brand: {{ row.item.payment_response?.card_brand }}</h7>
                                        </div>
                                    </template>

                                    <template #cell(phone_no)="row">
                                        <h7>{{ row.item.personal_info?.phone_number }}</h7>
                                    </template>

                                    <template #cell(amount)="row">
                                        <h7>{{  row.item.payment_response?.amount }}</h7>
                                    </template>

                                    <template #cell(store_amount)="row">
                                        <h7>{{  row.item.payment_response?.store_amount }}</h7>
                                    </template>

                                    <template #cell(status)="row">
                                        <div v-if="row.item.status === 'successful'">
                                            <b-badge variant="success" style="font-size: 13px; max-width: fit-content; text-transform: uppercase;">{{ row.item.status }}</b-badge>
                                        </div>
                                        <div v-if="row.item.status === 'failed'">
                                            <b-badge variant="danger" style="font-size: 13px; max-width: fit-content; text-transform: uppercase;">{{ row.item.status }}</b-badge>
                                        </div>
                                        <div v-if="row.item.status === 'cancelled'">
                                            <b-badge variant="warning" style="font-size: 13px; max-width: fit-content; text-transform: uppercase;">{{ row.item.status }}</b-badge>
                                        </div>
                                    </template>

                                    <template #cell(gw_status)="row">
                                        <div v-if="row.item.gw_status === 'VALID'">
                                            <b-badge variant="success" style="font-size: 13px; max-width: fit-content;">{{ row.item.gw_status }}</b-badge>
                                        </div>
                                        <div v-if="row.item.gw_status === 'FAILED'">
                                            <b-badge variant="danger" style="font-size: 13px; max-width: fit-content;">{{ row.item.gw_status }}</b-badge>
                                        </div>
                                        <div v-if="row.item.gw_status === 'CANCELLED'">
                                            <b-badge variant="warning" style="font-size: 13px; max-width: fit-content;">{{ row.item.gw_status }}</b-badge>
                                        </div>
                                    </template>

                                    <template #cell(tran_date)="row">
                                        <h7 v-if="row.item.payment_response">{{ row.item.payment_response?.tran_date }}</h7>
                                    </template>
                                </b-table>
                            </div>
                        </div>

                        <div v-else>
                            <loader />
                        </div>

                        <!-- <b-col md="6" class="my-1 p-0">
                            <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" class="my-0"></b-pagination>
                        </b-col> -->
                        <b-row class="mt-3">
                            <b-col xl="12" class="d-flex flex-wrap justify-content-start align-items-center" style="gap: 8px;">
                                <span>
                                    <!-- First Page Button (<<) -->
                                    <button class="pg-button" :disabled="currentPage === 1" @click="goToPage(1)">
                                        <b-icon icon="chevron-double-left"></b-icon>
                                    </button>
    
                                    <!-- Previous Page Button (<) -->
    
                                    <button class="pg-button ml-2" :disabled="currentPage === 1" @click="goToPage(currentPage - 1)">
                                        <b-icon icon="chevron-left"></b-icon>
                                    </button>
                                </span>

                                <!-- Page Number Display (Page X of Y) -->
                                <span class="align-self-center">
                                    <span class="align-self-center">
                                        <span class="d-flex align-items-center" style="gap: 6px;">
                                            <span>Page</span>
                                            <b-form-input v-model="currentPage" style="box-shadow: none; max-width: 40px;" @blur="validatePage" @keydown.enter="validatePage" :disabled="totalPages <= 1"></b-form-input>
                                            <span>of {{ totalPages }}</span>
                                        </span>
                                    </span>
                                </span>

                                <span>
                                    <!-- Next Page Button (>) -->
                                    <button class="mr-2 pg-button" :disabled="currentPage === totalPages" @click="goToPage(currentPage + 1)">
                                        <b-icon icon="chevron-right"></b-icon>
                                    </button>
    
                                    <!-- Last Page Button (>>) -->
                                    <button class="pg-button" :disabled="currentPage === totalPages" @click="goToPage(totalPages)">
                                        <b-icon icon="chevron-double-right"></b-icon>
                                    </button>
                                </span>
                            </b-col>
                        </b-row>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Container-fluid Ends-->
</div>
</template>

<script>
import { mapState } from 'vuex';
import { myHost } from '../../../../_helpers/host';
import loader from '../../loader/loader.vue';
import Multiselect from 'vue-multiselect';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';

export default {
    components: {
        loader,
        Multiselect
    },

    data() {
        return {
            host: myHost.host,
            selected: [],
            isDisabled: false,
            tablefields: [
                {
                    key: 'index',
                    label: '#'
                },
                {
                    key: 'user',
                    label: 'User',
                    sortable: true
                },
                {
                    key: 'value_a',
                    label: 'Request ID',
                    sortable: true
                },
                {
                    key: 'media',
                    label: 'Media / Channel', 
                    sortable: true
                },
                {
                    key: 'amount',
                    label: 'Amount',
                    sortable: true
                },
                {
                    key: 'store_amount',
                    label: 'Store Amount',
                    sortable: true
                },
                {
                    key: 'transaction_id',
                    label: 'Transaction ID',
                    sortable: true
                },
                {
                    key: 'status',
                    label: 'Status',
                    sortable: true
                },
                {
                    key: 'gw_status',
                    label: 'GW Status',
                    sortable: true
                },
                {
                    key: 'tran_date',
                    label: 'Transaction Date',
                    sortable: true
                }
            ],
            initialLoad: true,
            filterShow: false,
            subscriptionType: null,
            filter: null,
            totalRows: 1,
            currentPage: 1,
            perPage: 25,
            loadingPage: false,
            pageOptions: [25, 50, 100]
        };
    },

    computed: {
        ...mapState({
            packages: state => state.packages.package,
            payment_log: state => state.payment.payment_log,
            loading: state => state.payment.paymentLoading,
            error: state => state.payment.paymentError,
            count: state => state.payment.payment_log_count
        }),

        formattedSubscription() {
            return [{
                    value: null,
                    text: 'Select a subscription type',
                    disabled: true
                },
                ...this.packages.map(type => ({
                    value: type.id,
                    text: type.title + " (" + type.type + ")"
                }))
            ];
        },

        totalPages() {
            if (typeof this.totalRows === 'number' && !isNaN(this.totalRows) && this.totalRows > 0) {
                return Math.ceil(this.totalRows / this.perPage);
            }
            return 1; // Default to 1 if totalRows is invalid
        }
    },

    watch: {
        currentPage(newCurrentPage) {
            if (!this.initialLoad) {
                if (this.currentPage === null || this.currentPage === '') {
                    this.loadingPage = true
                }
                
                this.$router.replace({
                    path: '/system/payment-log',
                    query: {
                        page: newCurrentPage,
                        perPage: this.perPage
                    }
                });
                
                this.currentPage = newCurrentPage
                this.$store.dispatch("payment/fetchPaymentLog", {
                    perPage: this.perPage,
                    currentPage: newCurrentPage
                }).then(() => {
                    this.totalRows = this.count;
                    this.initialLoad = false
                });
            }
        },

        perPage(newperPage) {
            if (!this.initialLoad) {
                
                this.$router.replace({
                    path: '/system/payment-log',
                    query: {
                        page: this.currentPage,
                        perPage: newperPage
                    }
                });

                this.perPage = newperPage
                this.$store.dispatch("payment/fetchPaymentLog", {
                    perPage: newperPage,
                    currentPage: this.currentPage
                }).then(() => {
                    this.totalRows = this.count;
                    this.initialLoad = false
                });
            }
        }
    },

    created() {
        this.$store.dispatch("packages/fetchPackage")
    },

    mounted() {
        if (this.initialLoad) {
            if (!this.$route.query.page || !this.$route.query.perPage) {
                this.$router.replace({
                    path: this.$route.path,
                    query: {
                        page: this.currentPage,
                        perPage: this.perPage
                    }
                }).catch(err => {
                    if (err.name !== 'NavigationDuplicated') {
                        throw err;
                    }
                });
                this.fetchInitial();
            } else {
                this.currentPage = parseInt(this.$route.query.page);
                this.perPage = parseInt(this.$route.query.perPage);
                this.fetchInitial();
            }
        }
    },

    methods: {
        validatePage() {
            this.loadingPage = true;
            const totalPages = this.totalPages;
            
            if (!this.currentPage || isNaN(this.currentPage) || this.currentPage < 1) {
                this.currentPage = 1;
            } else if (Number(this.currentPage) > totalPages) {
                this.currentPage = totalPages; // Set to last valid page
            }

            this.loadingPage = false;
        },

        goToPage(page) {
            if (page < 1 || page > this.totalPages) return;
            this.currentPage = page;
        },

        formatDate(dateStr) {
            if (!dateStr) return ''

            const date = new Date(dateStr)

            const day = date.getDate()
            const month = date.toLocaleString('default', {
                month: 'long'
            })
            const year = date.getFullYear()

            const hours = date.getHours()
            const minutes = date.getMinutes().toString().padStart(2, '0')
            const ampm = hours >= 12 ? 'PM' : 'AM'
            const hour12 = hours % 12 || 12

            const getOrdinal = (n) => {
                const s = ['th', 'st', 'nd', 'rd']
                const v = n % 100
                return s[(v - 20) % 10] || s[v] || s[0]
            }

            return {
                date: `${day}${getOrdinal(day)} ${month}, ${year}`,
                time: `${hour12}:${minutes} ${ampm}`
            }
        },

        fetchInitial() {
            this.$store.dispatch("payment/fetchPaymentLog", {
                perPage: this.$route.query.perPage,
                currentPage: this.$route.query.page
            }).then(() => {
                this.totalRows = this.count;
                this.initialLoad = false;
            });
        },

        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },

        clearFilter() {
            this.filterShow = false;
            this.$router.replace({
                path: '/system/payment-log',
                query: {
                    page: this.currentPage,
                    perPage: this.perPage
                }
            });
            this.fetchInitial();
        },

        toggleFilterShow() {
            this.filterShow = !this.filterShow
        }
    }
};
</script>

<style scoped>
.table-danger {
    background-color: #f8d7da !important;
    color: #721c24 !important;
}
</style>
